/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Clubs_Invite_CodeInputs */

const en_us2_clubs_invite_code = /** @type {(inputs: Clubs_Invite_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code: ${i?.code}`)
};

const pt_br2_clubs_invite_code = /** @type {(inputs: Clubs_Invite_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código: ${i?.code}`)
};

const es_419_clubs_invite_code = /** @type {(inputs: Clubs_Invite_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código: ${i?.code}`)
};

const pt_pt2_clubs_invite_code = /** @type {(inputs: Clubs_Invite_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código: ${i?.code}`)
};

const fr_fr2_clubs_invite_code = /** @type {(inputs: Clubs_Invite_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code : ${i?.code}`)
};

const de_de2_clubs_invite_code = /** @type {(inputs: Clubs_Invite_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code: ${i?.code}`)
};

const it_it2_clubs_invite_code = /** @type {(inputs: Clubs_Invite_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codice: ${i?.code}`)
};

/**
* | output |
* | --- |
* | "Code: {code}" |
*
* @param {Clubs_Invite_CodeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_invite_code = /** @type {((inputs: Clubs_Invite_CodeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Invite_CodeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_invite_code(inputs)
	if (locale === "es-419") return es_419_clubs_invite_code(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_invite_code(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_invite_code(inputs)
	if (locale === "de-DE") return de_de2_clubs_invite_code(inputs)
	if (locale === "it-IT") return it_it2_clubs_invite_code(inputs)
	return en_us2_clubs_invite_code(inputs)
});
export { clubs_invite_code as "clubs.invite_code" }